import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {LogDto} from "@/store/player/types";
import {Keys} from "@/constants/key";
import SpriteUtils from "@/utils/sprite-utils";
import {ClanAction, ClanLogDto, ClanPosition} from "@/store/clan/types";
import {Tr} from "@/i18n/i18n";
import SkillUtils from "@/utils/skill-utils";
import ClanUtils from "@/utils/clan-utils";
import {WarriorClass} from "@/store/level/types";
import {ForceUtils} from "@/utils/force-utils";
import {CreatureUtils} from "@/utils/creature-utils";

export class ClanLogPanel extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, l: ClanLogDto) {
        super(scene);

        this.scene = scene;

        let timeText = TextUtils.addTextAdvanced(scene, l.loggedAt, -284, 22,
            '#ffdb60', 13, 'normal', 480, 'left', 2, Fonts.MYRIADPRO_REGULAR);

        let desc = Tr('igrokk') + ' ' + l.playerName + ' ' + Tr('clan.' + l.clanAction) + ' ' + (l.victimName ? Tr('igroka')  + ' ' + l.victimName : "") + '; ' +
            (l.count || l.details? Tr('details') + ': ':'') + (l.count ? SkillUtils.formatMoreThanMillion(l.count ): "") + this.getDetails(l);

        let descText = TextUtils.addTextAdvanced(scene, desc , -284, 42,
            '#e2e2e2', 13, 'normal', 480, 'left', 2, Fonts.MYRIADPRO_REGULAR);
        descText.setOrigin(0, 0)

        this.height = Math.max(70, descText.height + 45);

        const sep = SpriteUtils.addSprite(this.scene!, 0, this.height, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR).setOrigin(0.5, 0);

        this.add([timeText, descText, sep]);
    }

    private getDetails(l: ClanLogDto): string {
        if (l.details) {
            switch (l.clanAction) {
                case ClanAction.upgradeWallOfFame:
                    return  " " + CreatureUtils.getClassName(WarriorClass[l.details as keyof typeof WarriorClass]);
                case ClanAction.raise:
                case ClanAction.subsidence:
                    return  " " +  ClanUtils.getPositionName(ClanPosition[l.details as keyof typeof ClanPosition]);
                default:
                    return  " " + l.details;
            }
        }
        return "";
    }

}
